import axios from "../axios";

// Register a new user
export const registerUser = async (data) => {
  const response = await axios.post("/auth/register", data);
  return response.data;
};

// Send OTP to user's email
export const requestPasswordReset = async (email) => {
  try {
    const response = await axios.post("/auth/forgot-password", { email });
    return response.data;
  } catch (error) {
    // Get message from backend or fallback
    const message =
      error.response?.data?.message || "Failed to send verification code.";
    throw new Error(message);
  }
};

// Verify OTP and reset password
export const resetPassword = async ({ email, otp, password }) => {
  const response = await axios.post("/auth/reset-password", {
    email,
    otp,
    password,
  });
  return response.data;
};

